export default __webpack_public_path__ + "static/media/Caesar.944eea40.jpg";